import { Actions } from '../../interfaces'

import find from './find'
import { DeductibleType } from '@/entities/settings'

export const actions: Actions = {
  find,
}

export default {
  Model: { DeductibleType },
  actions: { [DeductibleType.name]: actions },
}
